// TODO Sentry initialization for web
export const initSentry = (App) => { return App; };

export const Sentry = {
  wrap: (App) => App,
  captureException: console.warn,
  captureEvent: console.warn,
};
